import React, { useEffect, useState } from "react";
import SelectMentor from "../Connect/SelectMentor";
import { Route, Routes } from "react-router-dom";
import MentorList from "../Connect/MentorList";
import Button from "../modules/Button";
import MultiSelect from "../modules/MultiSelect";
import DropBtn from "../modules/DropBtn";
import { mbaColleges, engColleges } from "../modules/CollegeList";
import { useSelector, useDispatch } from "react-redux";
import avatar from "../../Assets/svg/avatar-img.svg";
import ModalComponent from "../modules/Modal";
import Input from "../modules/Input";
import tick from "../../Assets/svg/green-bg-tick.svg";
import Avatars from "../modules/AvatarGroup";
import Connect from "./ConnectScholars";
import Connections from "./Connections";
import Requests from "./Requests";
import { api } from "../../Services";
import { addMentorInfo } from "../Connect/redux/actions";
import { useNavigate } from "react-router-dom";

function Scholars() {
  const dispatch =useDispatch()
  const [option, setOption] = useState(1);
  const [universities, setuniversities] = useState([]);
  const tokenData = useSelector((state) => state.tokens.tokens);
  const registeredData = useSelector((state) => state.register.registeredData);
  const [ModalData, setModalData] = useState({
    show: false,
    type: "confirm",
    title: "",
    countDown: " ",
    desc: "",
  });
  const navigate = useNavigate();
  const scholarContent = () => {
    return (
      <div className="feedback-content">
        <Avatars type='alumni'/>
        <div className=" md-title ">
          Find more than 100+ Alumni members on the platform
        </div>
        <div className="cred-btn">
          <Button
            onClickHandler={() =>
              navigate("/application/connect/alumni") 
            }
            value={"Start Networking"}
            type={"contained"}
          />
          <Button
            onClickHandler={() => setModalData({ ...ModalData, show: false })}
            value={"I’ll check it out later"}
            type={"only-text"}
          />
        </div>
      </div>
    );
  };

 
  useEffect(() => {
 
    const queryParams = new URLSearchParams(window.location.search);
    const value1 = queryParams.get("paramName");
    console.log(value1);
    let data = [];

    if (registeredData?.info?.course?.includes("ENGINEERING")|| registeredData?.info?.course?.includes("Engineering") ) {
      data = [
        ...new Set(
          engColleges?.map(
            (item) => item["Name of university/College"]
          )
        ),
      ];
    } else {
      data = [
        ...new Set(
          mbaColleges?.map(
            (item) => item["Name of university/College"]
          )
        ),
      ];
    }
    // console.log('data', data.length)
    setuniversities([...new Set(data.sort())]);
  }, []);
  return (
    <div className="mentor-page alumni-page scholar-page">
      <div className="mentor-options">
        <div
          onClick={() => setOption(1)}
          className={`option pointer ${option === 1 ? "selected" : ""}`}
        >
          Connect with fellow scholars
        </div>
        <div
          onClick={() => setOption(2)}
          className={`option pointer ${option === 2 ? "selected" : ""}`}
        >
          My Connections
        </div>
        <div
          onClick={() => setOption(3)}
          className={`option pointer ${option === 3 ? "selected" : ""}`}
        >
          Connection Requests
        </div>
      </div>
      {option === 1 ? (
        <Connect />
      ) : option === 2 ? (
        <Connections />
      ) : (
        <Requests />
      )}
      {ModalData.show && (
        <ModalComponent
          show={ModalData.show}
          handleClose={() => setModalData({ ...ModalData, show: false })}
          title={ModalData.title}
          content={ModalData.desc}
          className={
            ModalData.type === "request"
              ? "mentor-list"
              : ModalData.type === "network"
              ? "mentor"
              : "complate-modal"
          }
          noCross={
            (ModalData.type === "submit" || ModalData.type === "network") &&
            true
          }

          // countDown={ModalData.countDown}
        >
          {/* {ModalData.type === "confirm" ? (
          ) :ModalData.type === "network" ? (
            scholarContent()
          ) : ( */}
          {/* <Button
              onClickHandler={() => setModalData({ ...ModalData, type:'network', title:'', desc:'' })}
              value={"Okay"}
              type={"contained"}
            /> */}
          { ModalData.type === "network" ? (
            scholarContent()
          ) : (
            <Button
              onClickHandler={() =>
                setModalData({
                  ...ModalData,
                  show: false,
                  title: "",
                  //   show: false,
                  desc: "",
                })
              }
              value={"Okay"}
              type={"contained"}
            />
          )}

          {/* // )} */}
        </ModalComponent>
      )}
    </div>
  );
}

export default Scholars;
